import {useRef,useEffect, useState} from 'react';
import { useSelector,useDispatch } from 'react-redux';
import { showmodal,ajout,addOne } from "./ClientsSlice";
import axios from 'axios';

export default function ModalAjouter() {

    const ProduitsData = useSelector(state => state.clientsData);
    const modalShow = ProduitsData.modalShow;
    const id = useSelector(state => state.userData.id);

    const [loading,setLoading] =useState(false)
    const [etat,setEtat] =useState('')

    const designationField=useRef('')
    const contactField=useRef('')
    const telField=useRef('')
    const iceField=useRef('')
    const villeField=useRef('')
    const ribField=useRef('')

    const ViderChamps = () => {
        designationField.current.value = '';
        contactField.current.value = '';
        telField.current.value = '';
        iceField.current.value = '';
        villeField.current.value = '';
        ribField.current.value = '';
    }

    const Ajouter = async ()=> {
        const designation=designationField.current.value.trim()
        const contact=contactField.current.value.trim()
        const tel=telField.current.value.trim()
        const ice=iceField.current.value.trim()
        const ville=villeField.current.value.trim()
        const rib=ribField.current.value.trim()

        if(designation==="")
            {
                alert("Désignation vide");
                return;
            }
            setEtat('')
            setLoading(true)
        try {
            const apiUrl = process.env.REACT_APP_API_URL;
            const response = await axios.post(`${apiUrl}new/client/${id}`, {
                designation,
                contact,
                tel,
                ice,
                ville,
                rib,
            });
            if(response.data.status==="ok")
                {
                    const _id=response.data.id;
                    const data={_id,designation,contact,tel,ice,ville,rib};
                    dispatch(showmodal(false));
                    dispatch(ajout(true));
                    dispatch(addOne(data));
                    ViderChamps();
                }
            else if(response.data.status==="exist")
             {
                alert("Client déja existant");
            }
            else{
                setEtat('erreur');
            }
        } catch (error) {
            setEtat('erreur');
        }
        setLoading(false)
    }

    const dispatch= useDispatch();
    const Close = () => {
        dispatch(showmodal(false));
        ViderChamps();
        setEtat('');
        
    };

    useEffect(() =>{
        ViderChamps();
        setEtat('');
      },[]);

    return (
        <div className={`modal fade ${modalShow ? 'show' : ''}`} style={{ display: modalShow ? 'block' : 'none' }} role="dialog" aria-hidden="true">
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Ajouter un client</h5>
                    </div>
                    <div className="modal-body">
                    {etat==='erreur' ?
                                <div class="alert alert-danger  mb-4 text-center" role="alert">
                                <strong>Erreur de connexion</strong>
                            </div>                 
                        :
                        ''                    
                    }
                    <label className="form-label" for="designation">Nom client</label>
                    <input autoComplete="off" type="text" className="form-control" id="designation"  ref={designationField}></input>
                    
                    <label className="form-label" for="contact">CIN</label>
                    <input autoComplete="off" type="text" className="form-control" id="contact" ref={contactField}></input>


                    <label className="form-label" for="tel">Tel.</label>
                    <input autoComplete="off" type="text" className="form-control" lang="en" id="tel" ref={telField}></input>

                    <label className="form-label" for="ice">ICE</label>
                    <input autoComplete="off" type="text" className="form-control" lang="en" id="ICE"  ref={iceField}></input>

                    <label className="form-label" for="ville">Adresse</label>
                    <input autoComplete="off" type="text" className="form-control" lang="en" id="ville"  ref={villeField}></input>

                    <label className="form-label" for="ville">RIB</label>
                    <input autoComplete="off" type="text" className="form-control" lang="en" id="rib"  ref={ribField}></input>

                    </div>
                    <div className="modal-footer">
                        {loading ?
                        <>
                <div className="mt-4 d-flex justify-content-center">
                <button class="btn btn-success" type="button" disabled>
                <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                <span class="sr-only">Enregistrement...</span>
                </button>
                </div> 
                        </>
                        :
                        <>
                        <button type="button" className="btn btn-success" onClick={Ajouter}>Enregistrer</button>
                        <button type="button" className="btn btn-secondary" onClick={Close}>Annuler</button>
                        </>
                        }
                    </div>
                </div>
            </div>
        </div>
    );

    }


